import { createContext, useContext, useState, useEffect } from 'react';

const HI = {
  'Registration desk': 'पंजीकरण डेस्क', 'Register student': 'विद्यार्थी पंजीकृत करें',
  'Bulk registration': 'सामूहिक पंजीकरण', 'Section roster': 'अनुभाग सूची', 'Holds': 'रोक',
  'Gradebook': 'ग्रेडबुक', 'Grading grid': 'अंक तालिका', 'Moderation queue': 'मॉडरेशन कतार',
  'Grade changes': 'ग्रेड परिवर्तन', 'Credentials': 'प्रमाणपत्र',
  'Enter marks, moderate, publish, and handle grade changes with a full paper trail.': 'अंक दर्ज करें, मॉडरेट करें, प्रकाशित करें, और पूरे रिकॉर्ड के साथ ग्रेड परिवर्तन संभालें।',
  'Register students fast, run whole cohorts with a preview, manage rosters and holds.': 'विद्यार्थियों को तेज़ी से पंजीकृत करें, पूर्वावलोकन के साथ पूरे समूह चलाएँ, सूचियाँ और रोक प्रबंधित करें।',
  'Academic core': 'शैक्षणिक कोर', 'Terms': 'सत्र', 'Programmes': 'कार्यक्रम', 'Courses': 'पाठ्यक्रम',
  'Sections': 'अनुभाग', 'Reference data': 'संदर्भ डेटा', 'Overview': 'अवलोकन',
  'Registration': 'पंजीकरण', 'Grading': 'ग्रेडिंग', 'Hierarchy': 'संरचना', 'Customization': 'अनुकूलन',
  'Advisor workspace': 'सलाहकार कार्यक्षेत्र', 'Course registration': 'पाठ्यक्रम पंजीकरण',
  'My transcript': 'मेरी अंकतालिका', 'Open for registration': 'पंजीकरण के लिए खुला',
  'My registrations': 'मेरे पंजीकरण', 'My week': 'मेरा सप्ताह', 'My degree progress': 'मेरी डिग्री प्रगति',
  'Register for open sections, watch your waitlist spot and see your week.': 'खुले अनुभागों में पंजीकरण करें, अपनी प्रतीक्षा सूची देखें और अपना सप्ताह देखें।',
  'Nothing is open for registration right now.': 'अभी पंजीकरण के लिए कुछ भी खुला नहीं है।',
  'You have no registrations yet.': 'आपका अभी तक कोई पंजीकरण नहीं है।',
  'Your timetable fills in once you are registered.': 'पंजीकरण होते ही आपकी समय सारिणी भर जाएगी।',
  'Your advisees at a glance - standings, programme progress and this term\u2019s registrations.': 'आपके परामर्शी एक नज़र में - स्थिति, कार्यक्रम प्रगति और इस सत्र के पंजीकरण।',
  'Terms, programmes, courses and sections - one configurable model for schools and universities.': 'सत्र, कार्यक्रम, पाठ्यक्रम और अनुभाग - स्कूलों और विश्वविद्यालयों के लिए एक विन्यास योग्य मॉडल।',
  'People': 'लोग', 'Learning': 'शिक्षा', 'Money': 'वित्त', 'Campus': 'परिसर', 'Connect': 'संपर्क', 'Platform': 'प्लेटफ़ॉर्म',
  'Reconciliation': 'मिलान', 'Automation': 'स्वचालन', 'Integrations': 'एकीकरण', 'Documentation': 'दस्तावेज़',
  'Chat': 'चैट',
  'Dashboard': 'डैशबोर्ड', 'Students': 'विद्यार्थी', 'Admissions': 'प्रवेश', 'Academics': 'शैक्षणिक',
  'Attendance': 'उपस्थिति', 'Fees & Finance': 'शुल्क और वित्त', 'Communication': 'संचार',
  'Admin Center': 'प्रशासन केंद्र', 'Onboarding': 'ऑनबोर्डिंग', 'Sign out': 'साइन आउट',
  'Assistant': 'सहायक', 'Notifications': 'सूचनाएं', 'Mark all read': 'सभी पढ़ा हुआ चिह्नित करें',
  'No notifications': 'कोई सूचना नहीं', 'Welcome': 'स्वागत है', 'Security & MFA': 'सुरक्षा और MFA',
  'Search students, apps...': 'विद्यार्थी, आवेदन खोजें...',
  'Student': 'विद्यार्थी', 'Plan': 'योजना', 'Total': 'कुल', 'Paid': 'भुगतान', 'Balance': 'शेष',
  'Status': 'स्थिति', 'Actions': 'कार्रवाई', 'Pay online': 'ऑनलाइन भुगतान',
  'Record installment': 'किस्त दर्ज करें', 'Remind': 'याद दिलाएं',
  'Total arrears': 'कुल बकाया', 'Open invoices': 'खुले चालान',
  'My Report Cards': 'मेरे रिपोर्ट कार्ड', 'Attendance %': 'उपस्थिति %',
  'Released report cards': 'जारी रिपोर्ट कार्ड', 'My identity': 'मेरी पहचान',
  'No invoices in your scope.': 'आपके दायरे में कोई चालान नहीं।',
  'Hard rule: arrears never block academic or safeguarding records - optional services only':
    'कठोर नियम: बकाया कभी भी शैक्षणिक या सुरक्षा रिकॉर्ड को अवरुद्ध नहीं करता - केवल वैकल्पिक सेवाएं',
  // Fee plans
  'New fee plan': 'नई शुल्क योजना', 'Fee plans': 'शुल्क योजनाएं', 'Generate invoices': 'चालान बनाएं',
  'Create plan': 'योजना बनाएं', 'Installments': 'किस्तें', 'Amount (₹)': 'राशि (₹)', 'Grade': 'कक्षा',
  // Admissions
  'New inquiry': 'नई पूछताछ', 'New application inquiry': 'नई आवेदन पूछताछ', 'Enroll': 'नामांकन', 'Create': 'बनाएं',
  'inquiry': 'पूछताछ', 'applied': 'आवेदित', 'interview': 'साक्षात्कार', 'offered': 'प्रस्तावित',
  'waitlisted': 'प्रतीक्षा सूची', 'enrolled': 'नामांकित', 'declined': 'अस्वीकृत',
  // Attendance
  'Save attendance': 'उपस्थिति सहेजें', 'All present': 'सभी उपस्थित',
  'present': 'उपस्थित', 'absent': 'अनुपस्थित', 'late': 'विलंबित',
  // Academics
  'Timetable': 'समय सारणी', 'Report cards': 'रिपोर्ट कार्ड', 'AI drafts': 'AI ड्राफ्ट',
  'Generate Term 1 report cards': 'टर्म 1 रिपोर्ट कार्ड बनाएं', 'Approve': 'अनुमोदित करें', 'Release': 'जारी करें',
  'Period': 'कालांश', 'Mon': 'सोम', 'Tue': 'मंगल', 'Wed': 'बुध', 'Thu': 'गुरु', 'Fri': 'शुक्र',
  'Add slot': 'स्लॉट जोड़ें', 'Subject': 'विषय', 'Remove': 'हटाएं', 'Print': 'प्रिंट',
  'Attendance trend - last 14 days (%)': 'उपस्थिति प्रवृत्ति - पिछले 14 दिन (%)',
  'Dues aging (days)': 'बकाया आयु (दिन)',
  'Consents you control': 'आपके नियंत्रण में सहमतियां', 'AI learning assistant': 'AI शिक्षण सहायक',
  'Data processing (DPDP)': 'डेटा प्रोसेसिंग (DPDP)', 'Withdraw': 'वापस लें', 'Grant': 'प्रदान करें',
  'Withdrawing AI consent hides the assistant from your child instantly.': 'AI सहमति वापस लेने पर सहायक आपके बच्चे से तुरंत छिप जाता है।',
  'Receipts': 'रसीदें',
  'Paperless - delivered by email & WhatsApp, no printing': 'कागज रहित - ईमेल और WhatsApp द्वारा वितरित, कोई प्रिंटिंग नहीं',
  'No released report cards yet.': 'अभी तक कोई जारी रिपोर्ट कार्ड नहीं।',
};

const AR = {
  'Dashboard': 'لوحة التحكم', 'Students': 'الطلاب', 'Admissions': 'القبول', 'Academics': 'الأكاديميات',
  'Attendance': 'الحضور', 'Fees & Finance': 'الرسوم والمالية', 'Communication': 'التواصل',
  'Admin Center': 'مركز الإدارة', 'Onboarding': 'الإعداد', 'Sign out': 'تسجيل الخروج',
  'Operations': 'العمليات', 'Lifecycle': 'دورة الحياة', 'IAM & IGA': 'الهوية والحوكمة',
  'Assistant': 'المساعد', 'Notifications': 'الإشعارات', 'Mark all read': 'وضع علامة مقروء على الكل',
  'No notifications': 'لا توجد إشعارات', 'Welcome': 'مرحباً', 'Security & MFA': 'الأمان والمصادقة الثنائية',
  'Search students, apps...': 'ابحث عن الطلاب والطلبات...',
  'Student': 'الطالب', 'Plan': 'الخطة', 'Total': 'الإجمالي', 'Paid': 'المدفوع', 'Balance': 'الرصيد',
  'Status': 'الحالة', 'Actions': 'الإجراءات', 'Pay online': 'الدفع عبر الإنترنت',
  'Record installment': 'تسجيل قسط', 'Remind': 'تذكير',
  'Total arrears': 'إجمالي المتأخرات', 'Open invoices': 'الفواتير المفتوحة',
  'No invoices in your scope.': 'لا توجد فواتير في نطاقك.',
  'Hard rule: arrears never block academic or safeguarding records - optional services only':
    'قاعدة صارمة: المتأخرات لا تحجب السجلات الأكاديمية أو سجلات الحماية أبداً - الخدمات الاختيارية فقط',
  'New fee plan': 'خطة رسوم جديدة', 'Fee plans': 'خطط الرسوم', 'Generate invoices': 'إنشاء الفواتير',
  'Create plan': 'إنشاء الخطة', 'Installments': 'الأقساط', 'Amount (₹)': 'المبلغ', 'Grade': 'الصف',
  'New inquiry': 'استفسار جديد', 'Enroll': 'تسجيل', 'Create': 'إنشاء',
  'Save attendance': 'حفظ الحضور', 'All present': 'الجميع حاضرون',
  'present': 'حاضر', 'absent': 'غائب', 'late': 'متأخر',
  'Timetable': 'الجدول الزمني', 'Report cards': 'كشوف الدرجات', 'AI drafts': 'مسودات الذكاء الاصطناعي',
  'Approve': 'اعتماد', 'Release': 'إصدار', 'Subject': 'المادة', 'Remove': 'إزالة', 'Print': 'طباعة',
  'Period': 'الحصة', 'Mon': 'الاثنين', 'Tue': 'الثلاثاء', 'Wed': 'الأربعاء', 'Thu': 'الخميس', 'Fri': 'الجمعة',
  'Dues aging (days)': 'أعمار المستحقات (أيام)',
  'Receipts': 'الإيصالات',
  'Paperless - delivered by email & WhatsApp, no printing': 'بدون ورق - يتم التسليم عبر البريد الإلكتروني وواتساب، بدون طباعة',
  'Fee statements': 'كشوف الرسوم', 'Download statement': 'تنزيل الكشف',
  'Chat': 'المحادثات',
  'New application inquiry': 'استفسار طلب جديد',
  'Add slot': 'إضافة حصة',
  'Attendance trend - last 14 days (%)': 'اتجاه الحضور - آخر 14 يوماً (%)',
  'Generate Term 1 report cards': 'إنشاء كشوف درجات الفصل الأول',
  'My Report Cards': 'كشوف درجاتي',
  'No released report cards yet.': 'لا توجد كشوف درجات صادرة بعد.',
};

const DICTS = { hi: HI, ar: AR };

const I18nCtx = createContext({ lang: 'en', setLang: () => {}, t: (s) => s });
export const useI18n = () => useContext(I18nCtx);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem('or_lang') || 'en');
  const setLang = (l) => { localStorage.setItem('or_lang', l); setLangState(l); };
  const t = (s) => (DICTS[lang]?.[s] || s);
  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}
